import * as Linking from 'expo-linking';

import type { AppLinkingOptions } from './AppNavigation.props';

export const appNavigationLinking: AppLinkingOptions = {
  prefixes: [
    Linking.createURL('/', { scheme: 'sweetgreen-order' }),
    'https://*.sweetgreen.com',
    'https://sweetgreen.com',
    'order://',
  ],
  config: {
    initialRouteName: 'MainTabs',
    screens: {
      MainTabs: {
        screens: {
          HomeTab: {
            screens: {
              Home: { path: '', exact: true },
            },
          },
          MenuTab: {
            screens: {
              Location: { path: 'location', exact: true },
              // Note: MenuShort technically breaks the standard React Navigation NotFound fallback, such that all 404's route through the MenuScreen
              // @TODO: XP-3153 improve handling of 301 / 404
              MenuShort: { path: ':restaurantSlug', exact: true },
              Menu: { path: ':restaurantSlug/menu', exact: true },
              DeliveryMenu: {
                path: 'delivery/:addressId/menu',
                exact: true,
              },
              MenuCollection: {
                path: ':restaurantSlug/collections/:menuCollectionId',
                exact: true,
              },
              DeliveryMenuCollection: {
                path: 'delivery/:addressId/collections/:menuCollectionId',
                exact: true,
              },
            },
          },
          LoyaltyTab: {
            screens: {
              Sweetpass: { path: 'sweetpass', exact: true },
              Challenges: { path: 'challenges', exact: true },
            },
          },
          AccountTab: {
            initialRouteName: 'AccountMenu',
            screens: {
              AccountMenu: { path: 'account', exact: true },
              Profile: { path: 'profile', exact: true },
              SweetpassMembership: {
                path: 'sweetpass/membership',
                exact: true,
              },
              PaymentCredit: { path: 'payment', exact: true },
              Addresses: { path: 'addresses', exact: true },
              Orders: { path: 'orders', exact: true },
              Favorites: { path: 'favorites', exact: true },
              ReferFriend: { path: 'refer-friend', exact: true },
              AccountDietaryRestrictions: {
                path: 'account-dietary-restrictions',
                exact: true,
              },
            },
          },
        },
      },
      Modal: {
        screens: {
          ProductDetails: {
            path: ':restaurantSlug/:productSlug',
            exact: true,
          },
          EditProductDetails: {
            path: ':restaurantSlug/:productSlug/edit/:lineItemId',
            exact: true,
          },
          DeliveryProductDetails: {
            path: 'delivery/:addressId/:productSlug',
            exact: true,
          },
          DeliveryEditProductDetails: {
            path: 'delivery/:addressId/:productSlug/edit/:lineItemId',
            exact: true,
          },

          DeliveryOrderInFlight: {},

          ReorderConfirmLocation: {},
          ReorderChangeLocation: {},
          ReorderConflictReview: {},
          ReorderActiveBagWarning: {},

          PersonalData: { path: 'ca-data-requests', exact: true },
          PersonalDataDetails: {},

          Bag: {},
          Checkout: { path: 'checkout', exact: true },

          OrderStatus: { path: 'order-status/:orderId', exact: true },

          ScanToPay: { path: 'scan-to-pay', exact: true },
          Payments: {
            path: 'payment/list',
            exact: true,
          },
          PaymentCredit: {
            path: 'payment/select',
            exact: true,
          },
          PaymentMethodAdd: {
            path: 'payment/add',
            exact: true,
          },
          PaymentMethodEdit: {
            path: 'payment/:paymentMethodId',
            exact: true,
          },
          CreditAdd: {
            path: 'credit/add',
            exact: true,
          },
          CreditScan: {
            path: 'credit/scan',
            exact: true,
          },
          CreditDetails: {
            path: 'credit',
            exact: true,
          },

          AddressAdd: { path: 'addresses/add', exact: true },
          AddressEdit: {
            path: 'addresses/:addressId',
            exact: true,
          },

          DietaryRestrictions: {
            path: 'dietary-restrictions',
            exact: true,
          },
          RateOrder: { path: 'feedback/:orderId', exact: true },
          ShareLineItem: { path: 'share/:lineItemSlug', exact: true },
          OrderProductConfirmProduct: {
            path: '/order-product/:productSlug',
            exact: true,
          },
          SweetpassUpgrade: { path: 'sweetpass/upgrade', exact: true },
          OrderProductConfirmLocation: {
            path: '/order-product/:productSlug/confirm-location',
            exact: true,
          },
        },
      },
      Auth: {
        screens: {
          Login: { path: 'login', exact: true },
          Join: { path: 'join', exact: true },
          JoinVerification: { path: 'register/verify', exact: true },
          ForgotPassword: { path: 'forgot-password', exact: true },
        },
      },
      Error: {
        screens: {
          NotFound: { path: '*' },
        },
      },
      Maintenance: {
        screens: {
          MaintenanceMode: {},
        },
      },
    },
  },
};
